module.exports = __webpack_public_path__ + "img/Deathknight-dwarf-m-70.8f27bd7c.gif";